import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{yield\n  (hash weekDays=this.weekDays weeks=this.weeks dateRange=this.dateRange)\n}}")